<div
  class="ai-chatbot-credits-overlay"
  [class.slide-in-bottom]="slideIn()"
  [class.slide-out-bottom]="slideOut()"
>
  <div class="ai-chatbot-credits-overlay-content">
    @if (creditsRemaining() > 0) {
      <p class="ai-chatbot-credits-overlay-content-text">
        You have <b>{{ creditsRemaining() | number: '1.0-0' }} credits</b> left.
        <i>(This used {{ creditsUsed() | number: '1.2-2' }} credits.)</i>
      </p>
    } @else {
      <p class="ai-chatbot-credits-overlay-content-text">
        <b>0 credits</b> remaining
      </p>
    }
    <div class="ai-chatbot-credits-overlay-content-buttons">
      @if (creditsRemaining() < 2) {
        <button mat-flat-button color="primary" (click)="openCreditsModal()">
          Add Credits
        </button>
      }
      <button
        mat-icon-button
        (click)="closeCreditsOverlay()"
        aria-label="Close credits overlay"
      >
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
  </div>
</div>
